import { render, staticRenderFns } from "./string-array-service-config-field.component.vue?vue&type=template&id=2347bcac&scoped=true"
import script from "./string-array-service-config-field.component.vue?vue&type=script&lang=ts"
export * from "./string-array-service-config-field.component.vue?vue&type=script&lang=ts"
import style0 from "./string-array-service-config-field.component.vue?vue&type=style&index=0&id=2347bcac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2347bcac",
  null
  
)

export default component.exports